import React from 'react';
import { IndexRoute, Route } from 'react-router';
import Participants from './participants';

export default (
  <Route path="participantes">
    <IndexRoute component={props => <Participants {...props} />} />
  </Route>
);
